package com.exura.components.pageTypography

import com.exura.error
import com.exura.primary
import com.exura.success
import com.exura.ui.Dimens
import com.exura.ui.FontFamily
import com.exura.warning
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.link
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette

sealed interface TextKind : ComponentKind

val ExuraTextStyle = CssStyle<TextKind> {
    base {
        Modifier
            .fontFamily(FontFamily.INTER)
    }
}
// FONTS:
val ExuraPoppinsVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontFamily(FontFamily.POPPINS)
    }
}
// WEIGHTS:
val ExuraBaseWeightVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontWeight(FontWeight.Normal)
    }
}
val ExuraEmphasisedTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontWeight(FontWeight.Medium)
    }
}
val ExuraCommentaryTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontWeight(FontWeight.Light)
    }
}
// SIZES:
val ExuraUnderwriteTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontSize(Dimens.pageUnderwritingFontSize)
    }
}
val ExuraBodySizeTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontSize(Dimens.pageSectionBodyFontSize)
    }
}
val ExuraBodyHeaderTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontSize(Dimens.pageSecondaryHeaderFontSize)
    }
}
val ExuraHeroTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontSize(Dimens.pageHeroTextSize)
    }
}
val ExuraSectionHeaderTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontSize(Dimens.pageSectionHeaderFontSize)
    }
}
val ExuraPageHeaderTextVariant = ExuraTextStyle.addVariant {
    base {
        Modifier
            .fontSize(Dimens.pageHeaderFontSize)
    }
}
// COLORS:
val ExuraBaseColorVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .color(palette.color)
    }
}
val ExuraPrimaryControlTextVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .color(palette.primary)
    }
}
val ExuraSuccessTextVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .color(palette.success)
    }
}
val ExuraWarnTextVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .color(palette.warning)
    }
}
val ExuraErrorTextVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .color(palette.error)
    }
}
val ExuraSecondaryTextVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .color(
                if(colorMode.isLight) {
                    palette.color.lightened()
                } else {
                    palette.color.darkened()
                }
            )
    }
}
//PURPOSE:
val ExuraLinkTextVariant = ExuraTextStyle.addVariant {
    val palette = colorMode.toPalette()

    base {
        Modifier
            .color(palette.link.default)
            .cursor(Cursor.Pointer)
    }
}
